import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EndoDiagnosisDataModel} from '../../models/endo-diagnosis-data.model';
import {DiagnosisService} from '../../../../../../services/form/diagnosis.service';
import {DiagnosisDifficultyConfigurationModel} from '../../../../../../models/forms/custom/diagnosis/diagnosis-difficulty-configuration.model';
import {Constants} from '../../../../../../constants';

@Component({
  selector: 'app-diagnosis-prior-qa-dialog',
  templateUrl: './diagnosis-prior-qa-dialog.component.html',
  styleUrls: ['./diagnosis-prior-qa-dialog.component.scss']
})
export class DiagnosisPriorQaDialogComponent implements OnInit {
  model: EndoDiagnosisDataModel;
  configs: DiagnosisDifficultyConfigurationModel[] = [];

  constructor(private dialogRef: MatDialogRef<DiagnosisPriorQaDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: any,
              private diagnosisService: DiagnosisService) {
    this.model = data.data;
    this.configs = data.configs;
  }

  ngOnInit(): void {
    this.calculateQaValue();
  }

  save() {
    this.diagnosisService.saveDiagnosis(this.model).subscribe((res) => {
      this.calculateQaValue();
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.dialogRef.close();
  }

  calculateQaValue() {
    this.model.QValue = 0;
    Object.entries(this.model).forEach(
      ([key, value]) => {
        const diffConf = this.configs.find(p => p.FieldName === key);
        if (key.includes('pqa_')) {
          if (diffConf && value !== null && value !== Constants.emptyGuid) {
            const enu = diffConf.cfgDiagnosisDifficultyEnums.find(p => p.ValidValueItemID.toLowerCase() === (value as string).toLowerCase());
            if (enu) {
              this.model.QValue += enu.DifficultyLevel;
            }
          }
        }
      }
    );
    this.diagnosisService.saveDiagnosis(this.model).subscribe((res) => {
      //
    });
  }
}
